import { render, staticRenderFns } from "./ModalAssignUser.vue?vue&type=template&id=2a65d129&"
import script from "./ModalAssignUser.vue?vue&type=script&lang=js&"
export * from "./ModalAssignUser.vue?vue&type=script&lang=js&"
import style0 from "./ModalAssignUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports